import {API_BASE_URL} from './Settings';

export interface RegisterPayload {
    firstName: string;
    lastName: string;
    username: string;
    email: string;
    firmName: string;
    password: string;
}

export async function register(payload: RegisterPayload): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/auth/register`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        const errorJson = await response.json().catch(() => ({}));
        const message = errorJson.message || `Erreur ${response.status}`;
        throw new Error(message);
    }
}

export interface LoginPayload {
    username: string;
    password: string;
}

export async function login(payload: LoginPayload): Promise<{ token: string, firms: any, user: any }> {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        const errorJson = await response.json().catch(() => ({}));
        const message = errorJson.message || `Erreur ${response.status}`;
        throw new Error(message); // ⛔ interrompre le flux ici
    }


    const result = await response.json(); // { token, firms, user }

    // ✅ Persister l'utilisateur connecté dans localStorage
    localStorage.setItem(
        'user',
        JSON.stringify({
            token: result.token,
            username: payload.username,
            firms: result.firms,
            user: result.user
        })
    );

    return result;
}

export function getCurrentUser(): {
    token: string | null;
    username: string | null;
    firms?: any;
    user?: any;
} {
    const stored = localStorage.getItem('user');
    if (!stored) return {token: null, username: null};

    try {
        const parsed = JSON.parse(stored);
        return {
            token: parsed.token ?? null,
            username: parsed.username ?? null,
            firms: parsed.firms,
            user: parsed.user,
        };
    } catch {
        return {token: null, username: null};
    }
}

export function isAuthenticated(): boolean {
    const current = getCurrentUser();
    return !!current.token;
}

export async function forgotPassword(email: string) {
    console.log('forgotPassword called with email:', email);
    console.log('call ', `${API_BASE_URL}/users/forgotPassword`);
    const response = await fetch(`${API_BASE_URL}/users/forgotPassword`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({"email": email}),
    });

    if (!response.ok) {
        const errorJson = await response.json().catch(() => ({}));
        const message = errorJson.message || `Erreur ${response.status}`;
        throw new Error(message);
    }

}